export default {
  title: 'Indicaciones para el pago',
  paymentType: 'Tipo de pago',
  iban: 'IBAN',
  beneficiaryName: 'Nombre del beneficiario',
  beneficiaryAddress: 'Dirección del beneficiario',
  expirationDate: 'Fecha de vencimiento',
  multipleDates: 'Introducir varias fechas',
  expiration: 'Vencimiento',
  paymentDate: 'Fecha de pago',
  amount: 'Importe',
  addExpirationDate: 'Añadir nueva fecha de vencimiento',
  select: 'Seleccione la forma de pago',
  expirationDates: {
    title: 'Fecha de vencimiento',
    date: 'Fecha',
    amount: 'Importe'
  },
  paymentTypes: {
    receipt: 'Recibo domiciliado',
    transfer: 'Transferencia',
    issuedEffect: 'Efecto con vencimiento',
    effect: 'Efecto',
    promissoryNote: 'Pagaré',
    check: 'Cheque',
    payment: 'Pago Domiciliado',
    cash: 'Contado',
    others: 'Otros'
  }
}
